"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PrimaryNav = require("./PrimaryNav.style");
var _NavItems = _interopRequireDefault(require("../NavItems"));
const PrimaryNav = _ref => {
  let {
    menuItems,
    ModalComp
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_PrimaryNav.PrimaryNavStyle, {
    "data-testid": "left-nav",
    "data-test-id": "left-nav"
  }, /*#__PURE__*/_react.default.createElement(_NavItems.default, {
    isPrimaryNav: true,
    position: "left",
    menuItems: menuItems,
    ModalComp: ModalComp
  }));
};
var _default = exports.default = PrimaryNav;